var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"ux-dialog-wrap"},_vm._l((_vm.dialogs),function(dialog){return _c('w-dialog',{key:_vm.ow_loop_key(dialog),attrs:{"dialog":dialog}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }